import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

import { Request } from './request.model';

export interface RequestState extends EntityState<Request> {}

@Injectable()
@StoreConfig({
  name: 'request',
})
export class RequestStore extends EntityStore<RequestState> {
  constructor() {
    super();
  }
}
